import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { MatSort, Sort } from "@angular/material/sort";
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Notifications, NotificationsFilters } from '../../../commons/models/notifications';
import { LaravelNotificationsService } from '../../../commons/services/laravel/laravel-notifications.service';

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss']
})
export class NotificationsListComponent {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    pageSizeOptions = PAGE_SIZE_OPTIONS;

    constructor(private notificationService: LaravelNotificationsService) {}

    send: boolean;
    notifiche: Notifications[];

    @Input() notifications: Notifications;
    @Input() selectedNotifications: Notifications[];
    @Input() defaultFilters: NotificationsFilters;
    @Input() total: Observable<number>;

    @Input() displayedColumns: string[] = ["sent_at", "title", "body", "actions"]
    @Input() canAdd: boolean;
    @Input() canEdit: boolean;
    @Input() canSelect: boolean;

    @Output()
    onLoad: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
    @Output()
    onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
    @Output()
    onFilterChange: EventEmitter<NotificationsFilters> = new EventEmitter<NotificationsFilters>();

    @Output()
    onSelectNotifications : EventEmitter<Notifications> = new EventEmitter<Notifications>();
    @Output()
    onAddNotifications: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onEditNotifications: EventEmitter<Notifications> = new EventEmitter<Notifications>();
    @Output()
    onShowNotifications: EventEmitter<Notifications> = new EventEmitter<Notifications>();
    @Output()
    onAddSelectedNotification: EventEmitter<Notifications> = new EventEmitter<Notifications>();
    @Output()
    onRemoveSelectedNotification: EventEmitter<Notifications> = new EventEmitter<Notifications>();

    get selectedItems(): boolean {
    return this.selectedNotifications.length > 0;
    }

    ngAfterViewInit() {
        if (this.sort) {
            this.sort.sortChange.subscribe((sort) => {
            this.onSortChange.emit(sort);
            });
        }

        if (this.paginator) {
            this.paginator.page.subscribe((pageEvent) => {
            this.onPageChange.emit(pageEvent);
            });
        }
    }

    addNotification() {
        this.onAddNotifications.emit();
    }
    
    editNotification(notifications: Notifications) {
        this.onEditNotifications.emit(notifications);
    }
    
    selectNotification(notifications: Notifications) {
        this.onSelectNotifications.emit(notifications);
    }

    removeSelectedNotification(notifications: Notifications) {
        this.onRemoveSelectedNotification.emit(notifications)
    }

    onFilter(filters: NotificationsFilters) {
        this.paginator.firstPage();
        this.onFilterChange.emit(filters);
    }

    showNotification(notifications: Notifications) {
        this.onShowNotifications.emit(notifications);
    }

    formatSentAt(date: string | Date | null): string {
        if (!date) return '—';
        
        const parsedDate = typeof date === 'string' ? new Date(date) : date;
    
        if (isNaN(parsedDate.getTime())) return '—';
    
        return new Intl.DateTimeFormat('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(parsedDate);
    }

    sendNotification(notificationId: number) {
        if (!notificationId) {
            console.error("Errore: notificationId è undefined!");
            return;
        }
    
        this.notificationService.sendNotification(notificationId).subscribe({
            next: (response) => {
                console.log('Notifica inviata con successo', response);
                
                if (this.notifiche && Array.isArray(this.notifiche)) {
                    this.notifiche = this.notifiche.map(notification =>
                        notification.id === notificationId ? { ...notification, sent_at: response.sent_at } as Notifications : notification
                    );
                }
            },
            error: (error) => console.error('Errore nell’invio della notifica', error)
        });
    }
    
    
    
    
    
}